import { post, get, put, del, patch, delfunction } from './http-methods';

//while creating PR no need to add base url [remove from all urls below], it will be handled by proxy inside package.json
// const BASE_URL = process.env.REACT_APP_BASE_URL;

const BASE_URL =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8000'
    : window.location.origin;

//change in Api url , from api/v1/login/ to /api/v1/api/v1/login/  [Don't miss to merge this change.]
const loginApi = {
  login: payload => post(`${BASE_URL}/api/v1/login/`, payload),
  signup: payload => post(`${BASE_URL}/api/v1/signup/`, payload),
};

const passwordReset = {
  passwordResetEmail: payload =>
    post(`${BASE_URL}/api/v1/forgot_password/`, payload),
  verifyCode: payload => post(`${BASE_URL}/api/v1/verify/`, payload),
  passwordChange: payload =>
    post(`${BASE_URL}/api/v1/reset_password/`, payload),
};

const userList = {
  getUsers: config => get(`${BASE_URL}/api/v1/userlist/`, config),
  editUser: (id, payload) =>
    patch(`${BASE_URL}/api/v1/userlist/user/${id}/`, payload),
  deleteUser: id => del(`${BASE_URL}/api/v1/userlist/${id}/`),
  approveUser: (id, payload) =>
    patch(`${BASE_URL}/api/v1/userlist/verify-user/${id}/`, payload),
};

const riskAssessments = {
  getProductLines: config => get(`${BASE_URL}/api/v1/product-line/`, config),
  createProductLine: payload =>
    post(`${BASE_URL}/api/v1/product-line/`, payload),
  editProductLine: (id, payload) =>
    patch(`${BASE_URL}/api/v1/product-line/${id}/`, payload),
  deleteProductLine: id => del(`${BASE_URL}/api/v1/product-line/${id}/`),
  getProductLineModels: ({productLineId, config}) =>
    get(
      `${BASE_URL}/api/v1/product-line/product-model/${productLineId}/`,
      config,
    ),
  createProductModel: payload => post(`${BASE_URL}/api/v1/machine/`, payload),
  editProductModel: (id, payload) =>
    patch(`${BASE_URL}/api/v1/machine/${id}/`, payload),
  deleteProductModel: id => del(`${BASE_URL}/api/v1/machine/${id}/`),

  // create Risk Assessment
  createRiskAssessment: payload =>
    post(`${BASE_URL}/api/v1/risk-assessment/`, payload),
  // get Risk Assessments
  getRiskAssessments: (obj, config) => {

    if (obj.productLineId) {
      return get(
        `${BASE_URL}/api/v1/risk-assessment/product/${obj.productLineId}/${obj?.type ? `?type=${obj.type}` : ""}`,
        config,
      );
    } else if (obj.modelId) {
      return get(`${BASE_URL}/api/v1/risk-assessment/model/${obj.modelId}/${obj?.type ? `?type=${obj.type}` : ""}`, config);
    }
   
  },
  getRiskAssessmentById: id => get(`${BASE_URL}/api/v1/risk-assessment/${id}/`),
  deleteRiskAssessment: id => del(`${BASE_URL}/api/v1/risk-assessment/${id}/`),
  editRiskAssessment: (id, payload) =>
    patch(`${BASE_URL}/api/v1/risk-assessment/${id}/`, payload),
  getSubCategoriesForTask: () => get(`${BASE_URL}/api/v1/sub-categories/`),
  deletedRiskAssessment: config =>
    get(`${BASE_URL}/api/v1/risk-assessment/deleted/`, config),
  restoreRiskAssessment: id =>
    patch(`${BASE_URL}/api/v1/risk-assessment/restore/${id}/`),
  hardDeleteRiskAssessment: id =>
    del(`${BASE_URL}/api/v1/risk-assessment/delete/${id}/`),
  getRiskAssessmentInfo: id =>
    get(`${BASE_URL}/api/v1/risk-assessment/info/${id}/`),
};

const riskAssessmentsCore = {
  // get risk assessments tasks
  getRiskAssessmentsTasks: ({riskAssessmentId, config}) =>
    get(
      `${BASE_URL}/api/v1/risk-task/risk_assessment/${riskAssessmentId}/`,
      config,
    ),
  // get distinct task sub-category values actually used on tasks (for filter options)
  getTaskSubCategoryList: () =>
    get(`${BASE_URL}/api/v1/risk-task/task-sub-category-list/`),
  // get task detail
  getTaskDetail: taskId => get(`${BASE_URL}/api/v1/risk-task/${taskId}/`),
  // create risk assessment task
  createTask: payload => post(`${BASE_URL}/api/v1/risk-task/`, payload),
  updateTask: (id, payload) =>
    patch(`${BASE_URL}/api/v1/risk-task/${id}/`, payload),
  deleteTask: taskId => del(`${BASE_URL}/api/v1/risk-task/${taskId}/`),
  getSubCategoriesForEvents: config =>
    get(`${BASE_URL}/api/v1/event-sub-categories/`, config),
  createSubCategoriesForEvents: payload =>
    post(`${BASE_URL}/api/v1/event-sub-categories/`, payload),
  // marking state for exposure to events
  markNoEvents: (id, payload) =>
    patch(`${BASE_URL}/api/v1/event-task/${id}/`, payload),
  addEventSubCategory: payload =>
    post(`${BASE_URL}/api/v1/event-task/add-category/`, payload),
  deleteEventSubCategory: (id, payload) =>
    post(`${BASE_URL}/api/v1/event-task/remove-category/${id}/`, payload),
  // -----Risk Assessment nested data------
  // Limits of machine
  getMachineLimits: id =>
    get(`${BASE_URL}/api/v1/limit-machine/risk_assessment/${id}/`),
  addMachineLimits: (id, payload) =>
    id
      ? patch(`${BASE_URL}/api/v1/limit-machine/${id}/`, payload)
      : post(`${BASE_URL}/api/v1/limit-machine/`, payload),

  //Event details
  saveEventDetail: payload =>
    post(`${BASE_URL}/api/v1/event-assessment/`, payload),
  getEventDetail: ({eventId, parentRiskAssessmentId, config = {}}) => {
    const params = {...(config.params || {})};
    if (
      parentRiskAssessmentId != null &&
      parentRiskAssessmentId !== ''
    ) {
      params.parent_risk_assessment = parentRiskAssessmentId;
    }
    return get(`${BASE_URL}/api/v1/event-assessment/event/${eventId}/`, {
      ...config,
      params,
    });
  },
  updateEventDetail: (id, payload) =>
    patch(`${BASE_URL}/api/v1/event-assessment/${id}/`, payload),
  updateTaskMedia: (id, payload) =>
    post(`${BASE_URL}/api/v1/upload-media/task/${id}/`, payload),
  uploadMedia: payload => post(`${BASE_URL}/api/v1/upload-media/`, payload),
  
  // Add event to task
  addEventToTask: (taskId, payload) =>
    post(`${BASE_URL}/api/v1/risk-task/${taskId}/add-event/`, payload),
  // Update event for task
  updateEventForTask: (taskId, eventId, payload) =>
    patch(`${BASE_URL}/api/v1/risk-task/${taskId}/update-event/${eventId}/`, payload),
  deleteTaskMedia: (id, payload) =>
    delfunction(`${BASE_URL}/api/v1/risk-task/${id}/delete-media/`, payload),
  addAssumption: (id, payload) =>
    id
      ? patch(`${BASE_URL}/api/v1/assumption/${id}/`, payload)
      : post(`${BASE_URL}/api/v1/assumption/`, payload),
  getAssumption: id =>
    get(`${BASE_URL}/api/v1/assumption/risk_assessment/${id}/`),

  addRevisionHistory: (id, payload) =>
    id
      ? patch(`${BASE_URL}/api/v1/revision-history/${id}/`, payload)
      : post(`${BASE_URL}/api/v1/revision-history/`, payload),
  getRevisionHistory: id =>
    get(`${BASE_URL}/api/v1/revision-history/risk_assessment/${id}/`),

  addAttendance: payload => post(`${BASE_URL}/api/v1/attendance/`, payload),
  getAttendance: id =>
    get(`${BASE_URL}/api/v1/attendance/risk_assessment/${id}/`),
  getEmployee: () => get(`${BASE_URL}/api/v1/attendance-user/`),
  getRASummary: ({riskAssessmentId, config}) =>
    get(`${BASE_URL}/api/v1/summary/`, config),
  generateExcelId: payload =>
    post(`${BASE_URL}/api/v1/generate-excel/`, payload),
  generateExcel: id =>
    get(`${BASE_URL}/api/v1/generate-excel/unique-id/${id}/`),
  importEvent: payload => post(`${BASE_URL}/api/v1/import-event/`, payload),
  importRiskAssessment: (file, productId, machineId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('product_id', productId);
    if (machineId) {
      formData.append('machine_id', machineId);
    }
    return post(`${BASE_URL}/api/v1/import-risk-assessment/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getNewAttendanceData: (riskAssessmentId) => get(`${BASE_URL}/api/v1/general-attendance/?risk_assessment_id=${riskAssessmentId}`),
  deleteAttendanceRecord: data =>{
    if (data?.attendance_id) {
      const url = `${BASE_URL}/api/v1/general-attendance/?attendance_id=${data.attendance_id}`;
      return del(url);
    }
    
    // Second API call for deleting by id (date or session_id)
    if (data?.id) {
      const url = `${BASE_URL}/api/v1/general-attendance/?id=${data.id}`;
      return del(url);
    }
  },
  attendanceByDate: date =>
    get(`${BASE_URL}/api/v1/attendance-bydate/${date}/`),
  saveAttendanceSession: payload =>
    post(`${BASE_URL}/api/v1/general-attendance/`, payload),
  actionItemData: payload => post(`${BASE_URL}/api/v1/actionitems/`, payload),
  actionItemData: (id, payload) =>
    post(`${BASE_URL}/api/v1/actionitems/create-action-item/${id}/`, payload),
  actionItemListData: id =>
    get(`${BASE_URL}/api/v1/actionitems/create-action-item/${id}/`),
  actionItemEditData: (id, payload) =>
    patch(`${BASE_URL}/api/v1/actionitems/${id}/`, payload),
  actionItemDeleteData: Id => del(`${BASE_URL}/api/v1/actionitems/${Id}/`),
  getUserListData: () => get(`${BASE_URL}/api/v1/actionitems/user_list/`),
  deleteNote: id => patch(`${BASE_URL}/api/v1/event-task/${id}/clear-note/`),
  getSubCategoriesForEventsBasedId: id =>
    get(`${BASE_URL}/api/v1/events/${id}/subcategories/?search=`),
  getFailureModeData: params => get(`${BASE_URL}/api/v1/failure-mode-assessments/?${params.queryParams.toString()}`),
  bulkAddFailureModeData: payload => post(`${BASE_URL}/api/v1/failure-mode-assessments/bulk-add/`, payload),
  bulkUpdateFailureModeData: payload => patch(`${BASE_URL}/api/v1/failure-mode-assessments/bulk-update/`, payload),
  addUsersToRiskAssessment: (id, payload) => {
    return post(`${BASE_URL}/api/v1/risk-assessment/${id}/add-users/`, payload);
  },
  removeUserFromRiskAssessment: (id, userId) => 
    del(`${BASE_URL}/api/v1/risk-assessment/${id}/remove-user/${userId}/`),

  editAttendance: ( payload) => patch(`${BASE_URL}/api/v1/general-attendance/`, payload),

  checkAttendanceExists: ( payload) => post(`${BASE_URL}/api/v1/check-attendance-exists/`, payload),

  // Cybersecurity devices
  getDevices: craId =>
    get(`${BASE_URL}/api/v1/cybersecurity-device/?risk_assessment=${craId}`),
  getDevice: deviceId =>
    get(`${BASE_URL}/api/v1/cybersecurity-device/${deviceId}/`),
  createDevice: payload =>
    post(`${BASE_URL}/api/v1/cybersecurity-device/`, payload),
  updateDevice: (deviceId, payload) =>
    patch(`${BASE_URL}/api/v1/cybersecurity-device/${deviceId}/`, payload),
  deleteDevice: deviceId =>
    del(`${BASE_URL}/api/v1/cybersecurity-device/${deviceId}/`),
  getScoringReference: () =>
    get(`${BASE_URL}/api/v1/cybersecurity-scoring-reference/`),

};

const anonymousScoring = {
  startSession: () => post(`${BASE_URL}/api/v1/anonymous-scoring/session/`, {}),
  submitVote: payload => post(`${BASE_URL}/api/v1/anonymous-scoring/vote/${payload.sessionId}/`, payload),
  fetchResults: sessionId => get(`${BASE_URL}/api/v1/anonymous-scoring/results/${sessionId}/`),
  stopSession: sessionId => post(`${BASE_URL}/api/v1/anonymous-scoring/stop-session/${sessionId}/`, {}),
  saveVotingData: payload => post(`${BASE_URL}/api/v1/anonymous-scoring/save-voting-data/`, payload),
  getVotingData: eventTaskId => get(`${BASE_URL}/api/v1/anonymous-scoring/get-voting-data/${eventTaskId}/`),
  clearVotingData: eventTaskId => del(`${BASE_URL}/api/v1/anonymous-scoring/clear-voting-data/${eventTaskId}/`, {}),
  getProtectiveMeasures: eventTaskId => get(`${BASE_URL}/api/v1/anonymous-scoring/get-protective-measures/${eventTaskId}/`),
};

const feedback = {
  sendFeedback: payload => post(`${BASE_URL}/api/v1/feedback/`, payload),
  getFeedback: config => get(`${BASE_URL}/api/v1/feedback/`, config),
  sendFeedbackReply: payload =>
    post(`${BASE_URL}/api/v1/feedback-reply/`, payload),
};

const password = {
  changePassword: payload => post(`/api/v1/change-password/`, payload),
};

const termsConditions = {
  getTermsAndConditions: () => get('/api/v1/terms-and-conditions/'),
  getPrivacyPolicy: () => get('/api/v1/privacy-policy/'),
};

// Functional Safety Assessment APIs
const functionalSafety = {
  // Main assessment
  getFunctionalSafetyAssessment: (params) => get(`${BASE_URL}/api/v1/functional-safety/`, { params }),
  upsertFunctionalSafetyAssessment: (payload) => post(`${BASE_URL}/api/v1/functional-safety/upsert/`, payload),
  deleteFunctionalSafetyAssessment: (id) => del(`${BASE_URL}/api/v1/functional-safety/${id}/`),
  
  // Stats (calculated scores)
  getFunctionalSafetyStats: (params) => get(`${BASE_URL}/api/v1/functional-safety/stats/`, { params }),

  // MTTF Assessment
  createMTTFAssessment: (assessmentId, payload) => post(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/mttf/`, payload),
  updateMTTFAssessment: (assessmentId, mttfId, payload) => patch(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/mttf/${mttfId}/`, payload),
  deleteMTTFAssessment: (assessmentId, mttfId) => del(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/mttf/${mttfId}/`),

  // DCavg Assessment
  createDCavgAssessment: (assessmentId, payload) => post(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/dcavg/`, payload),
  updateDCavgAssessment: (assessmentId, dcavgId, payload) => patch(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/dcavg/${dcavgId}/`, payload),
  deleteDCavgAssessment: (assessmentId, dcavgId) => del(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/dcavg/${dcavgId}/`),

  // CCF Assessment
  createCCFAssessment: (assessmentId, payload) => post(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/ccf/`, payload),
  updateCCFAssessment: (assessmentId, ccfId, payload) => patch(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/ccf/${ccfId}/`, payload),
  deleteCCFAssessment: (assessmentId, ccfId) => del(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/ccf/${ccfId}/`),

  // HSR Assessment
  createHSRAssessment: (assessmentId, payload) => post(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/hsr/`, payload),
  updateHSRAssessment: (assessmentId, hsrId, payload) => patch(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/hsr/${hsrId}/`, payload),
  deleteHSRAssessment: (assessmentId, hsrId) => del(`${BASE_URL}/api/v1/functional-safety/${assessmentId}/hsr/${hsrId}/`),

  // Static data options
  getCCFOptions: () => get(`${BASE_URL}/api/v1/ccf-options/`),
  getHSROptions: () => get(`${BASE_URL}/api/v1/hsr-options/`),
  
  // Import
  importFunctionalSafety: (file, productId, machineId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('product_id', productId);
    if (machineId) {
      formData.append('machine_id', machineId);
    }
    return post(`${BASE_URL}/api/v1/import-functional-safety/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export const apiFunctions = {
  // getUser: (config) => get('https://jsonplaceholder.typicode.com/users',config),
  ...loginApi,
  ...passwordReset,
  ...userList,
  ...riskAssessments,
  ...riskAssessmentsCore,
  ...anonymousScoring,
  ...feedback,
  ...password,
  ...termsConditions,
  ...functionalSafety,
};